import React from "react";

import { Flashbar, FlashbarProps } from "@amzn/awsui-components-react"
import { jsxParser } from "src/utilities/jsxParser"
import { BannerProps } from "./BannerTypes";
import { convertUrlsToLinks } from "../utils/generalUtils";

export default (props: BannerProps) => {
    const processedMessage = convertUrlsToLinks(props.bannerMessage);
    
    return (
        <div className={props.options?.roundedCorners ? "" : "flashbar-container"}> 
            <Flashbar
                items={[{
                    type: props.bannerType,
                    content: jsxParser(processedMessage),
                    dismissible: !!props.options?.onDismiss,
                    onDismiss: props.options?.onDismiss,
                    id: props.bannerKey,
                }]} 
            />
        </div>
    )
}
